<template>
  <div class="workbench">
    <Layout>
      <template v-slot:aside>
        <div class="workbench__aside">
          <DeviceList/>
        </div>
      </template>
      <template v-slot:nav>
        <div class="workbench__nav">
          <DeviceTypes/>
        </div>
      </template>
      <template v-slot:content>
        <div class="workbench__content">
          <Label/>
          <DrawerForm/>
        </div>
      </template>
    </Layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Layout from './Layout.vue';
import DeviceTypes from './DeviceTypes.vue';
import DeviceList from './DeviceList.vue';
import Label from './3DLabel/index.vue';
import DrawerForm from './deviceForm/index.vue';

export default {
  components: {
    Layout,
    DeviceTypes,
    DeviceList,
    Label,
    DrawerForm,
  },
  data() {
    return {
    };
  },
  methods: {

  },
};
</script>
<style lang="less" scoped>
.workbench {
  height: calc(100vh - 46px);
  color: #ffffff;
  &__aside {
    width: 100%;
    height: 100%;
  }
  &__nav {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
  &__content {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
</style>
